import confetti from 'canvas-confetti';
import { useEffect } from 'react';

/**
 * Einmal Konfetti, wenn ein Auftrag wirklich mit Ergebnis fertig ist, wortgleich zur
 * Content-Factory (ergebnis-ansicht.tsx): 120 Teilchen, Streuung 70, aus dem oberen Drittel.
 *
 * Ohne Worker (`useWorker: false`): die Bibliothek legt sonst einen Worker aus einer
 * `blob:`-Adresse an, den eine strenge Content-Security-Policy still verbietet; im Hauptthread
 * ist eine einzelne kurze Animation unbedenklich. Kein Konfetti, wenn die Person weniger Bewegung
 * eingestellt hat oder der Browser kein Canvas zeichnen kann. Beim Verlassen der Seite raeumt
 * `reset()` Canvas und Animationsschleife sofort ab.
 */
export function useKonfetti(aktiv: boolean): void {
  useEffect(() => {
    if (!aktiv) return;
    let canvasNutzbar: boolean;
    try {
      canvasNutzbar = document.createElement('canvas').getContext('2d') !== null;
    } catch {
      canvasNutzbar = false;
    }
    if (!canvasNutzbar) return;
    const wenigerBewegung =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (wenigerBewegung) return;
    const feiern = confetti.create(undefined, { useWorker: false, resize: true });
    void feiern({ particleCount: 120, spread: 70, origin: { y: 0.3 } });
    return () => feiern.reset();
  }, [aktiv]);
}
